import { render } from "./PublicJobs.vue?vue&type=template&id=e2bfb91a"
import script from "./PublicJobs.vue?vue&type=script&lang=js"
export * from "./PublicJobs.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__